import $ from 'jquery';

$('.faq__item').each(function () {
    $(this).on('click', function(){

        $(this).toggleClass('active');
        
    });
});

if ($(window).width() < 600) {
    $('.footermain .footermain__title').on('click tap', function(){
        $(this).toggleClass('clicked');
        $(this).parent().find('.menuf').slideToggle();
    });
}
$('.zol').on('click', function(e){
    // e.preventDefault();
    $('html, body').animate({
        scrollTop: $('#formdom').offset().top - 100
    }, 500, 'linear');
});
$('.ask').on('click', function(e){
    // e.preventDefault();
    $('html, body').animate({
        scrollTop: $('#formdom').offset().top - 100
    }, 500, 'linear');
});
$('.pos__top').on('click', function() {
	var parent = $(this).closest('.pos__item');
	parent.toggleClass('actives');
	parent.find('.pos__gal').toggleClass('active');
});
if ($('body').hasClass('home')){
    $('.kontakt-menu a').on('click', function(e){
        e.preventDefault();
        $('html, body').animate({
            scrollTop: $('#kontakt').offset().top - 100
        }, 500, 'linear');
    });
    $('.casestudy-menu a').on('click', function(e){
        e.preventDefault();
        $('html, body').animate({
            scrollTop: $('#case-study').offset().top - 100
        }, 500, 'linear');
    });
    $('.oferta-menu a').on('click', function(e){
        e.preventDefault();
        $('html, body').animate({
            scrollTop: $('#oferta').offset().top - 100
        }, 500, 'linear');
    });
    $('.sklep-menu a').on('click', function(e){
        e.preventDefault();
        $('html, body').animate({
            scrollTop: $('#sklep').offset().top - 100
        }, 500, 'linear');
    });
}
$('.gobot__row').on('click', function(e){
    e.preventDefault();
    $('html, body').animate({
        scrollTop: $('#underslide').offset().top - 100
    }, 500, 'linear');
});
